export async function find(url: RequestInfo, cpf: string, uriRedirect: string) {

    return await fetch(url + '/api/find', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                'cpf': cpf,
                'redirect_uri': uriRedirect
            }
        )
    })
        .then(response => response.json())
        .catch(err => {
            console.log(err);
        });
}